import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { App } from "./App";
import { store } from "./store/store";
import { LanguageProvider } from "./translations/i18n";
import ThemeRoot from "./theme/ThemeRoot";
import "./styles.css";

document.documentElement.lang = "bs";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeRoot>
        <LanguageProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </LanguageProvider>
      </ThemeRoot>
    </Provider>
  </React.StrictMode>,
);
